import { IconButton } from 'component/Button/IconButton'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import css from './BackButton.module.scss'

type Props = {
  onBack?(): void
}

export const BackButton = observer(({ onBack }: Props) => {
  const onBackInner = useLatestCallback(() => {
    if (onBack) onBack()
    else controller.openStart()
  })

  return <IconButton className={css.button} link action={onBackInner}>
    <Icon name="arrow_back" size={20} />
  </IconButton>
})
